import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useTranslation } from 'react-i18next'
import { Loader2, CheckCircle, XCircle, TrendingUp } from 'lucide-react'
import type { PipelineStats } from '../../types/response'

interface StatsCardsProps {
    stats: PipelineStats | undefined
    isLoading: boolean
}

const StatsCards = ({ stats, isLoading }: StatsCardsProps) => {
    const { t } = useTranslation('report_waf')

    const cards = [
        {
            title: t('pipeline.stats.running'),
            value: stats?.running ?? 0,
            icon: Loader2,
            iconColor: 'text-blue-600',
            iconBg: 'bg-blue-100 dark:bg-blue-900/30',
        },
        {
            title: t('pipeline.stats.success'),
            value: stats?.completed ?? 0,
            icon: CheckCircle,
            iconColor: 'text-green-600',
            iconBg: 'bg-green-100 dark:bg-green-900/30',
        },
        {
            title: t('pipeline.stats.failed'),
            value: stats?.failed ?? 0,
            icon: XCircle,
            iconColor: 'text-red-600',
            iconBg: 'bg-red-100 dark:bg-red-900/30',
        },
        {
            title: t('pipeline.stats.success_rate'),
            value: `${stats?.success_rate?.toFixed(1) ?? 0}%`,
            icon: TrendingUp,
            iconColor:
                (stats?.success_rate ?? 0) > 90
                    ? 'text-green-600'
                    : 'text-amber-600',
            iconBg:
                (stats?.success_rate ?? 0) > 90
                    ? 'bg-green-100 dark:bg-green-900/30'
                    : 'bg-amber-100 dark:bg-amber-900/30',
        },
    ]

    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {cards.map((card) => (
                <Card key={card.title}>
                    <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                        <CardTitle className="text-sm font-medium">
                            {card.title}
                        </CardTitle>
                        <div
                            className={`${card.iconBg} ${card.iconColor} rounded-lg p-2`}
                        >
                            <card.icon className="h-4 w-4" />
                        </div>
                    </CardHeader>
                    <CardContent>
                        <div className="text-2xl font-bold">
                            {isLoading ? '...' : card.value}
                        </div>
                    </CardContent>
                </Card>
            ))}
        </div>
    )
}

export default StatsCards
